<template>
  <div>
    <el-dialog class="invoiceDialog" :append-to-body="true" title="发票信息" 
      :visible.sync="collectionShow" width="45%">
      <div>用户发票信息填写二维码</div>
      <qr style="text-align: center;display: flex;margin-left: 120px;" :logoSrc="logoSrc"
                    :text="text"></qr>
    </el-dialog>
    
  </div>
</template>

<script>
import Qr from '../../../../components/Qr.vue'
export default {
  components: { Qr },
  data(){
    return{
      logoSrc: require("@/assets/png/planQRLogo.png"),
      text:'',
      collectionShow:false,
    }
  },
  methods:{
    beforeOpen(){
      this.collectionShow = true
      let uri = process.env["VUE_APP_INVOICE_ADD_H5_SERVE"]
      this.text = uri + `?planId=${this.$store.state.planId}`
    }
  },
}
</script>

<style>

</style>